import { values } from "lodash";
import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";

export const AUS_V2_SELECT_VALUES = {
  COUNTRIES: "COUNTRIES_V2",
  GENDERS: "AUS_V2_GENDER",
  MARITAL_STATUS: "AUS_V2_MARITAL_STATUS",
  VISA_TYPE: "AUS_V2_VISA_TYPE",
  SECURITY_QUESTIONS: "AUS_V2_SECURITY_QUESTIONS",
  AUS_V2_OTHER_COUNTRY_DOCUMENT_TYPE: "AUS_V2_OTHER_COUNTRY_DOCUMENT_TYPE",
};

export const ausV2Schema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      applicantNumber: {
        label: "Applicant number",
        type: TYPES.TEXT,
      },
      siteId: {
        label: "Referral Site",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID History",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      botRuns: {
        label: "Number of bot runs",
      },
      userEmail: {
        label: "User contact email",
        type: TYPES.EMAIL,
      },
      submissionEmail: {
        label: "User submission email",
        type: TYPES.TEXT,
      },
      tmpApplicantId: {
        label: "Temporary Applicant ID",
        type: TYPES.TEXT,
      },
      startedAt: {
        label: "Started At",
        type: TYPES.DATE,
      },
      completedAt: {
        label: "Completed At",
        type: TYPES.DATE,
      },
    },
  },
  personalInfoSegment: {
    label: "Personal information",
    type: TYPES.SEGMENT,
    data: {
      firstName: {
        label: "First name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Last name",
        type: TYPES.TEXT,
        required: true,
      },
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      birthDate: {
        label: "Date of birth",
        type: TYPES.DATE,
        required: true,
      },
      birthCountry: {
        label: "Country of birth",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      birthState: {
        label: "State of birth",
        type: TYPES.TEXT,
        required: true,
      },
      birthCity: {
        label: "City of birth",
        type: TYPES.TEXT,
        required: true,
      },
      maritalStatus: {
        label: "Marital status",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.MARITAL_STATUS,
        required: true,
      },
      residenceCountry: {
        label: "Usual country of residence",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      userPhone: {
        label: "Personal / business phone number",
        type: TYPES.TEXT,
        required: true,
      },
      haveOtherNames: {
        label: "Are you known by any other names or aliases?",
        type: TYPES.CHECKBOX,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.GENDERS,
        required: true,
      },
      visaType: {
        label: "Choose visa type",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.VISA_TYPE,
        required: true,
      },
      travelReason: {
        label: "Travel reason details",
        type: TYPES.TEXT,
        required: true,
      },
      addressLine1: {
        label: "Address Line 1",
        type: TYPES.TEXT,
        required: true,
      },
      addressLine2: {
        label: "Address Line 2",
        type: TYPES.TEXT,
      },
      country: {
        label: "Country",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      city: {
        label: "City",
        type: TYPES.TEXT,
        required: true,
      },
      postalCode: {
        label: "Postal Code",
        type: TYPES.TEXT,
        required: true,
      },
    },
  },
  passport_information: {
    label: "Passport information",
    type: TYPES.SEGMENT,
    data: {
      passportNumber: {
        label: "Passport number",
        type: TYPES.TEXT,
        required: true,
      },
      passportIssuingAuthority: {
        label: "Issuing authority",
        type: TYPES.TEXT,
        required: true,
      },
      passportIssueCountry: {
        label: "Issuing country",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      currentCitizenship: {
        label: "Current citizenship",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        required: true,
      },
      passportGrantNumber: {
        label: "Grant number",
        type: TYPES.TEXT,
        required: false,
      },
      passportIssueDate: {
        label: "Date of issue",
        type: TYPES.DATE,
        required: true,
      },
      passportExpiryDate: {
        label: "Date of expiry",
        type: TYPES.DATE,
        required: true,
      },
      haveOtherNationalIdCard: {
        label: "Do you have a national identity card?",
        type: TYPES.CHECKBOX,
      },
      idCardInformation: {
        label: "Identity card information",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "haveOtherNationalIdCard",
        nested: {
          idFirstName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "idCardInformation",
          },
          idLastName: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "idCardInformation",
          },
          idNumber: {
            label: "Identification number",
            type: TYPES.TEXT,
            path: "idCardInformation",
          },
          idIssuingCountry: {
            label: "Issuing country",
            type: TYPES.SELECT,
            values: AUS_V2_SELECT_VALUES.COUNTRIES,
            path: "idCardInformation",
          },
          idIssueDate: {
            label: "Date of issue",
            type: TYPES.DATE,
            path: "idCardInformation",
          },
          idExpireDate: {
            label: "Expiration date",
            type: TYPES.DATE,
            path: "idCardInformation",
          },
        },
      },
      isCurrentlyStateless: {
        label: "Are you currently stateless?",
        type: TYPES.CHECKBOX,
      },
      statelessReason: {
        label: "Reason for no citizenship or statelessness",
        type: TYPES.TEXT,
        dependsOn: "isCurrentlyStateless",
      },
      holdOtherCitizenship: {
        label: "Do you hold citizenship in any other country?",
        type: TYPES.CHECKBOX,
      },
      otherCitizenship: {
        label: "Other countries of citizenship",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.COUNTRIES,
        dependsOn: "holdOtherCitizenship",
      },
      haveOtherPassportOrTravelDocument: {
        label:
          "Do you hold current passports or travel documents for any other countries?",
        type: TYPES.CHECKBOX,
      },
      otherDocumentType: {
        label: "Document type",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.AUS_V2_OTHER_COUNTRY_DOCUMENT_TYPE,
      },
      haveOtherIdentityDocuments: {
        label: "Do you have other identity documents?",
        type: TYPES.CHECKBOX,
      },
      otherIdentityDocument: {
        label: "Other identity document information",
        type: TYPES.NESTED,
        newTable: true,
        dependsOn: "haveOtherIdentityDocuments",
        nested: {
          otherIdentityFirstName: {
            label: "Given name",
            type: TYPES.TEXT,
            path: "otherIdentityDocument",
          },
          otherIdentityLastName: {
            label: "Surname",
            type: TYPES.TEXT,
            path: "otherIdentityDocument",
          },
          otherIdentityNumber: {
            label: "Identification number",
            type: TYPES.TEXT,
            path: "otherIdentityDocument",
          },
          otherIdentityIssuingCountry: {
            label: "Issuing country",
            type: TYPES.SELECT,
            values: AUS_V2_SELECT_VALUES.COUNTRIES,
            path: "otherIdentityDocument",
          },
          otherIdentityDocumentType: {
            label: "Document type",
            type: TYPES.SELECT,
            values: AUS_V2_SELECT_VALUES.AUS_V2_OTHER_COUNTRY_DOCUMENT_TYPE,
            path: "otherIdentityDocument",
          },
        },
      },
    },
  },
  security_questions: {
    label: "Security questions",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion1: {
        label:
          "Have you ever been charged with any offence that is currently awaiting legal action?",
        type: TYPES.CHECKBOX,
      },
      securityQuestion2: {
        label:
          "Have you ever been convicted of an offence in any country (including any conviction which is now removed from official records)?",
        type: TYPES.CHECKBOX,
      },
      securityQuestion3: {
        label:
          "Have you ever been the subject of a domestic violence or family violence order, or any other order, of a tribunal or court or other similar authority, for the protection of another person?",
        type: TYPES.CHECKBOX,
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security question",
        type: TYPES.SELECT,
        values: AUS_V2_SELECT_VALUES.SECURITY_QUESTIONS,
      },
      securityAnswer: {
        label: "Answer",
        type: TYPES.TEXT,
        required: true,
      },
      signatureOfApplicant: {
        label: "Signature of applicant",
        type: TYPES.TEXT,
        required: true,
      },
      consentDeclaration: {
        label: "Agree with Consent and Declaration",
        type: TYPES.CHECKBOX,
      },
      termsConditions: {
        label: "Agree with Terms & Conditions",
        type: TYPES.CHECKBOX,
      },
      parental_consent: {
        label: "Parental consent (if applicable)",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          parentGuardianName: {
            label: "Parent / Guardian's Name",
            type: TYPES.TEXT,
            required: false,
          },
          parentGuardianSignature: {
            label: "Signature of parent or guardian",
            type: TYPES.TEXT,
            required: false,
          },
        },
      },
    },
  },
  filesSegment: {
    label: "Files",
    type: TYPES.SEGMENT,
    data: {
      files: {
        label: "Files",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          passport: {
            label: "Passport",
            type: TYPES.TEXT,
            path: "files",
          },
        },
      },
    },
  },
};
